<template lang="pug">
  div.record_content(v-if="loadingPro==='loadedPro' && loadingAL==='loadedAL'")
    div.img
      van-swipe(:autoplay="autoplay")
        van-swipe-item(v-for="(item, index) in images", :key="index")
          img(:src='item')
    div.detail
      div.top
        p.title {{contentData.name}}
        p.integral {{contentData.integral}}{{$t('integral')}}
      div.detail_tips
        p.tips {{contentData.description}}
    van-button(v-if="contentData.maxBuyNumber === '0'", round, disabled, class="over_btn") {{$t('soldOut')}}
    van-button(v-else-if="contentData.limitCount === '0'", round, disabled, class="over_btn") {{$t('purchased')}}
    van-button(v-else, type="danger", round, class="buy_btn", @click="buyHandle") {{$t('buy')}}
    van-popup(v-model="rolePop", closeable, round, close-icon="close")
      van-form(@submit="checkRole")
        van-field(v-if="isArea", :value="area", readonly, :placeholder="this.$t('selectRecion')", @click="showArea=true")
        van-field(:value="server", readonly, :placeholder="this.$t('selectService')", @click="showServer=true")
        van-field(:value="role", readonly, :placeholder="this.$t('selectRoll')", @click="showRole=true")
        van-button(type="danger", round, class="pay_btn") {{$t('pay')}}
    van-popup(v-model="showArea", position="bottom")
      van-picker(show-toolbar, :columns="areaColumns", @confirm="areaConfirm", @cancel="showArea=false", :confirm-button-text="sure", :cancel-button-text="back")
    van-popup(v-model="showServer", position="bottom")
      van-picker(show-toolbar, :columns="serverColumns", @confirm="serverConfirm", @cancel="showServer=false", :confirm-button-text="sure", :cancel-button-text="back")
    van-popup(v-model="showRole", position="bottom")
      van-picker(show-toolbar, :columns="roleColumns", @confirm="roleConfirm", @cancel="showRole=false", :confirm-button-text="sure", :cancel-button-text="back")
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Content',
  data(){
    return{
      autoplay: 3000,
      images: [],
      contentData: {},
      rolePop: false,
      area: '',
      areaId: '',
      server: '',
      serverId: '',
      role: '',
      roleId: '',
      showArea: false,
      showServer: false,
      showRole: false,
      areaColumns: [],
      serverColumns: [],
      roleColumns: [],
      isArea: true
    }
  },
  created(){
    this.getProduct({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        id: this.$route.query.id,
        language: this.lang
    })
    this.getAreaList({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
    })
  },
  methods: {
    ...mapActions('record', ['getProduct', 'pay']),
    ...mapActions(['getAreaList', 'getServerList', 'getGameRoleList']),
    buyHandle(){
      this.rolePop = true;
    },
    checkRole(){
      if(this.areaColumns.length < 2){
        this.pay({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          productId: this.$route.query.id,
          integral: this.contentData.integral,
          serverId: this.serverId,
          roleId: this.roleId,
          phoneModel: this.phoneModel,
          clientPlat: this.clientPlat,
          channelId: this.channelId,
          areaId: this.areaList.areaInfoList[0].id,
          cpUid: this.cpUid,
          language: this.lang
        })
      } else {
        this.pay({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          productId: this.$route.query.id,
          integral: this.contentData.integral,
          serverId: this.serverId,
          roleId: this.roleId,
          phoneModel: this.phoneModel,
          clientPlat: this.clientPlat,
          channelId: this.channelId,
          areaId: this.areaId,
          cpUid: this.cpUid,
          language: this.lang
        })
      }
    },
    areaConfirm(val){
      this.area = val
      this.showArea = false
      this.areaList.areaInfoList.map(v => {
        if(v.areaName === val){
          this.areaId =  v.id
        }
      })
      this.getServerList({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        areaId: this.areaId
      })
    },
    serverConfirm(val){
      this.server = val
      this.showServer = false
      this.serverList.serverList.map(v => {
        if(v.serverName === val){
          this.serverId = v.serverId
        }
      })
      if(this.areaColumns.length < 2){
        this.getGameRoleList({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          cpUid: this.cpUid,
          areaId: this.areaList.areaInfoList[0].id,
          serverId: this.serverId
        })
      } else {
        this.getGameRoleList({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          cpUid: this.cpUid,
          areaId: this.areaId,
          serverId: this.serverId
        })
      }
    },
    roleConfirm(val){
      this.role = val
      this.showRole = false
      this.roleList.gameRoleList.map(v => {
        if(v.roleName === val){
          this.roleId = v.roleId
        }
      })
    }
  },
  computed: {
    ...mapGetters(['lang', 'cpUid', 'uid', 'deviceId', 'token', 'appid', 'phoneModel', 'clientPlat', 'channelId', 'serverList', 'loadingSL', 'roleList', 'loadingRL', 'areaList', 'loadingAL']),
    ...mapGetters('record', ['product', 'loadingPro', 'payList', 'paying']),
    sure: $vm => {
      return $vm.$t('sure')
    },
    back: $vm => {
      return $vm.$t('return')
    },
  },
  mounted(){
    this.$watch('loadingPro', val => {
      if(val === 'loadedPro'){
        this.images = this.product.integerProduct.iconList.split(',');
        this.contentData = this.product.integerProduct
      }
    })
    this.$watch('loadingAL', val => {
      if(val === 'loadedAL'){
        this.areaColumns = this.areaList.areaInfoList.map(val => {
          return val.areaName
        })
        if(this.areaColumns.length < 2){
          this.areaId = this.areaList.areaInfoList[0].id
          this.isArea = false
          this.getServerList({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token,
            areaId: this.areaList.areaInfoList[0].id
          })
        }
      }
    })
    this.$watch('loadingSL', val => {
      if(val === 'loadedSL'){
        this.serverColumns = this.serverList.serverList.map(val => {
          return val.serverName
        })
        if(this.areaColumns.length > 1){
          this.showServer = true
        }
      }
    })
    this.$watch('loadingRL', val => {
      if(val === 'loadedRL'){
        this.roleColumns = this.roleList.gameRoleList.map(val => {
          return val.roleName
        })
        this.showRole = true
      }
    })
    this.$watch('paying', val => {
      if(val === 'payed'){
        if(this.payList === 'success'){
          this.rolePop = false
          Toast.success(this.$t('buySuccess'));
        } else {
          return false
        }
        this.getProduct({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token,
            id: this.$route.query.id,
            language: this.lang
        })
      }
    })
  }
}
</script>

<style lang="scss">
.record_content{
  margin: 10px;
  .van-popup--center.van-popup--round{
    border-radius: 10px;
  }
  .van-popup--center{
    width: 70%;
  }
  .van-icon-close{
    margin-top: -15px;
    margin: -15px;
  }
  .van-form{
    margin: 20px 25px;
  }
  .van-field__body{
    &::after {
      position: absolute;
      top: 50%;
      right: -4px;
      margin-top: -5px;
      border: 3px solid;
      border-color: transparent transparent #dcdee0 #dcdee0;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      opacity: 0.8;
      content: '';
    }
  }
  .van-cell{
    border: 1px solid #ebebeb;
    margin-bottom: 10px;
    padding: 5px 10px;
    &::after{
      border: 0px;
    }
  }
  .over_btn{
    width: 90%;
    left: 5%;
    padding: 15px;
  }
  .buy_btn{
    width: 90%;
    left: 5%;
    padding: 15px;
  }
  .pay_btn{
    width: 100%;
    left: 0;
    padding: 15px;
  }
  p{
    margin: 0;
  }
  .img{
    width: 100%;
    max-height: 250px;
    overflow: hidden;
    border-radius: 10px;
    img{
      width: 100%;
    }
  }
  .detail{
    margin: 20px 0;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 2px #ebebeb;
    .top{
      margin: 0 10px;
      padding: 20px 0 10px 0;
      border-bottom: 1px solid #ebebeb;
    }
    .title{
      text-align: left;
      font-size: 16px;
      line-height: 16px;
    }
    .integral{
      text-align: right;
      font-size: 16px;
      line-height: 16px;
      margin-top: -16px;
    }
    .detail_tips{
      margin: 0 10px;
      font-size: 12px;
      line-height: 24px;
      padding-top: 5px;
      padding-bottom: 10px;
    }
  }
}
</style>
